import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CasesIteratorComponent } from './cases-iterator.component';

@Component({
  selector: 'app-case-page',
  templateUrl: './case-page.component.html',
  styleUrls: ['./case-page.component.scss'],
  imports: [CommonModule, TranslateModule, CasesIteratorComponent]
})
export class CasePageComponent implements OnInit {

  caseNumber$: Observable<number>;

  constructor(private route: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.caseNumber$ = this.route.paramMap.pipe(map(_ => +_.get('caseNumber')));
  }

}
